// extracted by mini-css-extract-plugin
module.exports = {"routerOutlet":"PageContent_routerOutlet__1D-VH"};